import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import "core-js/modules/es.array.concat.js";
import { getBrandToken } from "@faire/help-center-utils/serialized-data/getBrand";
import { getRetailerToken } from "@faire/help-center-utils/serialized-data/getRetailer";
import { QueryParameters as ISelfServeBrandOrdersSearch } from "@faire/web-api/api/help-center/self-serve-brand-orders-search/get";
import { useQuery as useSelfServeBrandOrdersSearchQuery } from "@faire/web-api/api/help-center/self-serve-brand-orders-search/get-hooks";
import { trackHelpCenterOrderShowMoreClick } from "@faire/web-api/events/helpCenter/click/orderShowMore";
import { useEffect, useState } from "react";
import { BRAND_ORDERS_PAGE_SIZE } from "../consts";
import { useIssueType } from "./useIssueType";
/**
 *  This hook is used to search brand orders for the self-serve order select page.
 * @returns PaginatedBrandOrderData
 */
export var useSearchPaginatedBrandOrders = function useSearchPaginatedBrandOrders(_ref) {
  var _getRetailerToken, _getBrandToken, _brandOrderResponse$p, _brandOrderResponse$p2;
  var _ref$query = _ref.query,
    query = _ref$query === void 0 ? "" : _ref$query;
  var _useState = useState(1),
    _useState2 = _slicedToArray(_useState, 2),
    currentPage = _useState2[0],
    setCurrentPage = _useState2[1];
  var _useState3 = useState(undefined),
    _useState4 = _slicedToArray(_useState3, 2),
    brandOrders = _useState4[0],
    setBrandOrders = _useState4[1];
  var retailerToken = (_getRetailerToken = getRetailerToken()) !== null && _getRetailerToken !== void 0 ? _getRetailerToken : "";
  var brandToken = (_getBrandToken = getBrandToken()) !== null && _getBrandToken !== void 0 ? _getBrandToken : "";
  var _useIssueType = useIssueType(),
    issueType = _useIssueType.issueType;
  var _useSelfServeBrandOrd = useSelfServeBrandOrdersSearchQuery(ISelfServeBrandOrdersSearch.build({
      query: query,
      page: currentPage,
      pageSize: BRAND_ORDERS_PAGE_SIZE
    })),
    brandOrderResponse = _useSelfServeBrandOrd.data,
    isLoading = _useSelfServeBrandOrd.isLoading,
    searchBrandOrdersByQuery = _useSelfServeBrandOrd.refetch,
    dataUpdatedAt = _useSelfServeBrandOrd.dataUpdatedAt;
  var totalPages = (_brandOrderResponse$p = brandOrderResponse === null || brandOrderResponse === void 0 ? void 0 : (_brandOrderResponse$p2 = brandOrderResponse.pagination_data) === null || _brandOrderResponse$p2 === void 0 ? void 0 : _brandOrderResponse$p2.page_count) !== null && _brandOrderResponse$p !== void 0 ? _brandOrderResponse$p : 1;
  var hasMoreOrders = function hasMoreOrders() {
    if (query !== "") {
      return false;
    }
    return currentPage < totalPages;
  };
  var showMoreOrders = function showMoreOrders() {
    trackHelpCenterOrderShowMoreClick(retailerToken, brandToken, issueType);
    if (hasMoreOrders()) {
      setCurrentPage(currentPage + 1);
    }
  };
  useEffect(function () {
    if (query !== "") {
      setCurrentPage(1);
    }
  }, [query]);
  useEffect(function () {
    searchBrandOrdersByQuery().then(function (response) {
      var _response$data;
      var nextPageOrders = (_response$data = response.data) === null || _response$data === void 0 ? void 0 : _response$data.brand_orders;
      if (nextPageOrders) {
        setBrandOrders(function (prevBrandOrders) {
          return [].concat(_toConsumableArray(prevBrandOrders !== null && prevBrandOrders !== void 0 ? prevBrandOrders : []), _toConsumableArray(nextPageOrders));
        });
      }
    });
  }, [searchBrandOrdersByQuery, currentPage]);
  useEffect(function () {
    searchBrandOrdersByQuery().then(function (response) {
      var _response$data2;
      var nextPageOrders = (_response$data2 = response.data) === null || _response$data2 === void 0 ? void 0 : _response$data2.brand_orders;
      if (nextPageOrders) {
        setBrandOrders(nextPageOrders);
      }
    });
  }, [searchBrandOrdersByQuery, query]);
  return {
    isLoading: isLoading,
    brandOrders: brandOrders,
    hasMoreOrders: hasMoreOrders,
    showMoreOrders: showMoreOrders,
    dataUpdatedAt: dataUpdatedAt
  };
};